import get from 'lodash/get';
import React from 'react';
import PropTypes from 'prop-types';
import TreeView from '@Containers/TreeView';
import './TaxonomyLookupModalContent.scss';

function TaxonomyLookupModalContent({
  suggestConfig,
  suggestInit,
  getTreeView,
  showEmptyResult,
  startLoading,
  stopLoading,
  boundOperator,
  applyResultsFromTreeView,
  selectedItems,
  initTreeView,
  resetTreeView,
}) {
  const treeViewOptions = {
    onEmptyResult: showEmptyResult,
    onLoadingStart: startLoading,
    onLoadingEnd: stopLoading,
  };

  const applyResults = (selectedTaxonomies, selectedCustom, totalHitCount) => {
    applyResultsFromTreeView(selectedTaxonomies, selectedCustom, totalHitCount);
  };

  const handleGet = (params) => {
    return getTreeView(params, suggestInit);
  };
  const getInitailQuery = () => {
    const search = get(suggestInit, 'search');
    const query = {
      text: '',
      boundOperator,
    };
    if (!search || search.length < 2) {
      return query;
    }
    const terms = search.includes(';') ? search.split(';') : [search];
    if (terms.length === 1) {
      query.text = search;
    }
    return query;
  };

  return (
    <section className="taxonomyLookupModal__content">
      <TreeView
        taxonomyType={suggestConfig.queryLet.taxonomy}
        taxonomiesGetter={handleGet}
        selectedItems={null}
        onChange={applyResults}
        options={treeViewOptions}
        initialQuery={getInitailQuery()}
        selectedCustomItems={selectedItems}
        onInit={initTreeView}
        onReset={resetTreeView}
      />
    </section>
  );
}

TaxonomyLookupModalContent.propTypes = {
  suggestConfig: PropTypes.object,
  suggestInit: PropTypes.object,
  selectedItems: PropTypes.array,
  boundOperator: PropTypes.string,
  showEmptyResult: PropTypes.func.isRequired,
  startLoading: PropTypes.func.isRequired,
  stopLoading: PropTypes.func.isRequired,
  getTreeView: PropTypes.func.isRequired,
  initTreeView: PropTypes.func.isRequired,
  applyResultsFromTreeView: PropTypes.func.isRequired,
  resetTreeView: PropTypes.func.isRequired,
};

export default TaxonomyLookupModalContent;
